<template>
    <div class="x-title"
        :class="size ? `x-title--${size}` : ''">
        <span class="x-title-icon"></span>
        <p v-if="title"
            :title="title">{{ title }}
            <template v-if="isChild">
                <span class="tag">{{parentAppName}}的子应用</span>
            </template>
        </p>
        <slot></slot>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'XTitle',

    props: {
        size: String,
        title: String,
        isChild: {
            Type: Boolean,
            default: false
        },
        parentAppName: String
    },

    computed: {
        ...mapState({
            base: state => state.app.base,
        })
    }
}
</script>

<style lang="less">
@import '~common/less/var.less';

.x-title {
    display: flex;
    padding: 18px 0;
    align-items: center;
    &-icon {
        width: 12px;
        height: 12px;
        margin-right: 8px;
        border-radius: 50%;
        border: 3px solid @color-blue;
    }
    p {
        flex: auto 1 1;
        margin: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        font-weight: 700;
        font-size: 16px;
        line-height: 1.5;
    }

    &.x-title--large {
        padding: 24px 0;
        p {
            color: #333333;
            font-size: 24px;
        }
    }
    .tag {
        font-size: 12px;
        display: inline-block;
        color: #4c99fe;
        border: 1px solid #4c99fe;
        border-radius: 2px;
        padding: 3px 4px;
        line-height: 1;
        margin-left: 6px;
    }
}
</style>

